var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.currentGroupType
    ? _c(
        "v-list",
        { staticClass: "py-0", attrs: { dark: "" } },
        _vm._l(_vm.groups, function (group, index) {
          return _c(
            "v-list-group",
            {
              key: `${group.GroupName}-${index}`,
              attrs: { "no-action": "", "sub-group": !_vm.isBaseLevel },
            },
            [
              _c(
                "v-list-tile",
                { attrs: { slot: "activator" }, slot: "activator" },
                [
                  _vm.isBaseLevel
                    ? _c(
                        "v-list-tile-action",
                        [_c("v-icon", [_vm._v(_vm._s(_vm.getIcon(group)))])],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("v-list-tile-title", [_vm._v(_vm._s(group.GroupName))]),
                  _vm._v(" "),
                  !_vm.isBaseLevel
                    ? _c(
                        "v-list-tile-action",
                        [_c("v-icon", [_vm._v(_vm._s(_vm.getIcon(group)))])],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(
                _vm.getSortedMonitoringFeatures(group.MonitoringFeatureIds),
                function (item, subIndex) {
                  return _c(
                    "v-list-tile",
                    {
                      key: `${item.mfId}-${subIndex}`,
                      attrs: {
                        ripple: "",
                        "active-class": "activeLink",
                        to: {
                          name: "monitoringfeature",
                          params: { monitoringFeatureId: item.mfId },
                        },
                      },
                    },
                    [_c("v-list-tile-title", [_vm._v(_vm._s(item.name))])],
                    1
                  )
                }
              ),
              _vm._v(" "),
              group.Children
                ? _c("SideMenuGrouper", {
                    attrs: {
                      groups: group.Children,
                      currentLevel: _vm.currentLevel + 1,
                      groupSettings: _vm.groupSettings,
                    },
                  })
                : _vm._e(),
            ],
            2
          )
        }),
        1
      )
    : _c(
        "v-list",
        { attrs: { dark: "" } },
        _vm._l(
          _vm.getSortedMonitoringFeatures(_vm.groups),
          function (item, subIndex) {
            return _c(
              "v-list-tile",
              {
                key: `${item.mfId}-${subIndex}`,
                attrs: {
                  ripple: "",
                  "active-class": "activeLink",
                  to: {
                    name: "monitoringfeature",
                    params: { monitoringFeatureId: item.mfId },
                  },
                },
              },
              [
                _c("v-list-tile-action"),
                _vm._v(" "),
                _c("v-list-tile-title", [_vm._v(_vm._s(item.name))]),
              ],
              1
            )
          }
        ),
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }